<template>
  <PortalWidget :widget="widgetTitle">
    <div>
      <div 
        v-if="!isLoading"
        class="form-horizontal"
      >
        <!-- Display current billing plan -->
        <Field
          :label="$t('ACCOUNT_BILLING_PLAN_CURRENT')"
          :hide-label="false"
          :has-tooltip="true"
          :tooltip-text="$t('ACCOUNT_BILLING_PLAN_CURRENT_TT')"
        >
          <template #element>
            <div> 
              <div class="col-sm-4 col-md-2 p-t-7">
                {{ billingPlan.plan.name | planDisplayName | titleCase }}
              </div>
            </div>
          </template>
        </Field>
        <Field
          v-if="billingPlan && billingPlan.nextChargeDT"
          :label="$t('NEXT_CHARGE_DATE')"
          :hide-label="false"
          :has-tooltip="true"
          :tooltip-text="$t('NEXT_CHARGE_DATE_TT')"
        >
          <template #element>
            <div> 
              <div class="col-sm-4 col-md-2 p-t-7">
                {{ formattedNextChargeDT }}
              </div>
            </div>
          </template>
        </Field>
        <Field
          v-if="billingPlan && (!isBillingPlanCustom || billingPlan.isBillingPlanV2)"
          :label="$t('ACCOUNT_BILLING_PLAN_MONTHLY_FEE')"
          :hide-label="false"
          :has-tooltip="true"
          :tooltip-text="$t('ACCOUNT_BILLING_PLAN_MONTHLY_FEE_TT')"
        >
          <template #element>
            <div> 
              <div class="col-sm-4 col-md-2 p-t-7">
                ${{ (billingPlan.plan.renewingCharge || 0).toFixed(2) }} /
                {{ (billingPlan.plan.numberOfMonthsToRecur === 12) ? $t('ACCOUNT_BILLING_SCHEDULE_ANNUALLY') : $t('ACCOUNT_BILLING_SCHEDULE_MONTHLY') }}
              </div>
            </div>
          </template>
        </Field>

        <div class="form-group m-t-10">
          <div class="col-sm-9 col-md-9 col-md-offset-3 col-sm-offset-3">
            <button
              v-t="'ACCOUNT_BILLING_VIEW_PRICING_BUTTON'"
              class="btn btn-lg btn-primary"
              @click.prevent="openModal"
            />
          </div>
        </div> 

        <CurrentPricingModal
          v-if="showModal"
          @close="closeModal"
        />
      </div>
      <div v-else>
        <Loader />
        <span v-t="'LOADING'" />
      </div>
    </div>
  </PortalWidget>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import messages from '../../locales';
import titleCase from '@/core/filters/titleCase';
import planDisplayName from '@/core/filters/planDisplayName';
import Field from '@/core/components/LabelAndElement/LabelAndElement';
import CurrentPricingModal from './CurrentPricingModal';

export default {
  components: {
    Field,
    CurrentPricingModal,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      widgetTitle: { title: this.$i18n.t('ACCOUNT_BILLING_PLAN_HEADER'), iconClass: 'typcn typcn-cog' },
      showModal: false,
    };
  },
  filters: {
    titleCase, 
    planDisplayName
  },
  computed: {
    ...mapState('billingSettingsStore', ['billingPlan']),
    formattedNextChargeDT() {
      return this.billingPlan?.nextChargeDT ? moment.utc(this.billingPlan.nextChargeDT).format('MMMM D, YYYY') : '';
    },
    isBillingPlanCustom() {
      return this.billingPlan?.accountType === 'Custom';
    }
  },
  created() {
  },
  methods: {
    openModal() {
      this.showModal = true;  
    },
    closeModal() {
      this.showModal = false; 
    },
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>